import type { TProgressStep } from '@/shared/lib/progress';
import React from 'react';
import { ProgressBarStep } from './ProgressBarStep/ProgressBarStep';
import styles from './ProgressSteps.modules.scss';

interface IProgressStepsProps {
	steps: TProgressStep[];
}

export const ProgressSteps: React.FC<IProgressStepsProps> = ({ steps }) => {
	return (
		<div className={styles.paymentSteps}>
			{steps.map((step) => (
				<ProgressBarStep
					key={step.id}
					type={step.status}
					// width={`calc((100% - 2*${steps.length - 1}px) / ${steps.length})`}
				/>
			))}
		</div>
	);
};
